// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright-module--copyright--1ariN","copyright-m":"Copyright-module--copyright-m--3_m-F"};